import { motion, AnimatePresence } from 'framer-motion'
import React from 'react'

const RenovationElevator = ({ url, overlayUrl }) => (
  <div className="sticky top-[40vh] lg:top-[50vh] inline-flex">
    <img src={url} alt="" className="w-full h-auto top-8 lg:-translate-y-2/4" />
    <AnimatePresence>
      {overlayUrl && (
        <motion.img
          src={overlayUrl}
          alt=""
          className="absolute inset-0 z-10 lg:-translate-y-2/4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.1 }}
        />
      )}
    </AnimatePresence>
  </div>
)

export default RenovationElevator
